import { render, staticRenderFns } from "./newComManagementAnswers.vue?vue&type=template&id=30cf8c6b&scoped=true"
import script from "./newComManagementAnswers.vue?vue&type=script&lang=js"
export * from "./newComManagementAnswers.vue?vue&type=script&lang=js"
import style0 from "./newComManagementAnswers.vue?vue&type=style&index=0&id=30cf8c6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cf8c6b",
  null
  
)

export default component.exports